import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { GlobalStyles } from "./theme/globalStyles";
import ErrorBoundary from "./components/common/ErrorBoundary/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import { DonationProvider } from './contexts/DonationContext';
import { ToastContainer } from 'react-toastify';
import { EmailProvider } from "./contexts/EmailContext";
import 'react-toastify/dist/ReactToastify.css';

// Add global error handler for AWS SDK errors
window.addEventListener('error', (event) => {
  // Check if the error is related to AWS SDK
  if (event.message && 
     (event.message.includes('Cannot access') || 
      event.message.includes('before initialization') ||
      event.message.includes('vendor-aws'))) {
    
    // Hide loading animation if it exists
    const loadingElement = document.getElementById('loading');
    if (loadingElement) {
      loadingElement.style.display = 'none';
    }
    
    // Prevent the error from breaking the entire app
    event.preventDefault();
  }
});

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container missing in index.html");
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <DonationProvider>
        <AuthProvider>
          <GlobalStyles />
          <Router>
            <EmailProvider>
              <App />
            </EmailProvider>
            <ToastContainer />
          </Router>
        </AuthProvider>
      </DonationProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
